import React from "react";
import cartire from "../../assets/images/car_tire.png";
import cartirewhite from "../../assets/images/car_tire_white.png";

const LoadingIcon = ({ white }) => {
  return (
    <div className="flex space-x-1 items-end relative ">
      <div className="rotate-180">
        <div className="space-y-0.5  ">
          <div className="w-6 h-0.5 animate-flash  rounded-full bg-gray-500"></div>
          <div className="w-4 h-0.5 animate-flashs   rounded-full bg-gray-400"></div>
          <div className="w-3 h-0.5 animate-flasht  rounded-full bg-gray-300"></div>
        </div>
      </div>
      <img
        src={white ? cartirewhite : cartire}
        alt="carire"
        className="animate-spin font-italic w-6 h-6 absolute -top-2 left-5"
      />
    </div>
  );
};

export default LoadingIcon;



export const LoadingSpinner = ({ classname }) => {
  return (
    <div className={`flex justify-center items-center h-full`}>
      <div
        className={`border-4 ${classname} border-t-transparent rounded-full animate-spin`}
      ></div>
    </div>
  );
};
